module.exports = __webpack_public_path__ + "img/August.6534f648.png";